import moment from "moment";
import Gantt from 'frappe-gantt';

document.addEventListener('turbo:load', () => {
  initGanttModal();
});

document.addEventListener('turbo:render', () => {
  initGanttModal();
});

const RECURRENCES_DURATION_DATA = {
  daily: { days: 1, warnDays: 0 },
  weekly: { days: 7, warnDays: 2 },
  biweekly: { days: 14, warnDays: 5 },
  monthly: { days: 30, warnDays: 5 },
  quarterly: { days: 90, warnDays: 15 },
  semiannual: { days: 180, warnDays: 15 },
  annual: { days: 365, warnDays: 30 }
};

const COMPLIANCE_ACTIVITY_FIELDS_LIST = [
  'compliance_activity_name',
  'compliance_activity_start_date',
  'compliance_activity_deadline',
  'compliance_activity_recurrence'
];

function addRecurrence(date, recurrence) {
  const dateTime = new Date(date.getTime());

  switch (recurrence) {
    case 'daily': dateTime.setDate(dateTime.getDate() + 1); break;
    case 'weekly': dateTime.setDate(dateTime.getDate() + 7); break;
    case 'biweekly': dateTime.setDate(dateTime.getDate() + 14); break;
    case 'monthly': dateTime.setMonth(dateTime.getMonth() + 1); break;
    case 'quarterly': dateTime.setMonth(dateTime.getMonth() + 3); break;
    case 'semiannual': dateTime.setMonth(dateTime.getMonth() + 6); break;
    case 'annual': dateTime.setFullYear(dateTime.getFullYear() + 1); break;
    default:
      console.error('Invalid recurrence', recurrence);
      break;
  }
  return dateTime;
}

function initGanttModal() {
  const activityGanttModal = document.getElementById('ganttModal');
  if (!activityGanttModal) return;

  let ganttInstance;

  const nameInput = document.getElementById('compliance_activity_name');
  const startDatepickerInput = document.getElementById('compliance_activity_start_date');
  const deadlineDatepickerInput = document.getElementById('compliance_activity_deadline');
  const recurrenceSelectInput = document.getElementById('compliance_activity_recurrence');

  function getDateInputsValues() {
    let start_date = startDatepickerInput?.value ? moment(startDatepickerInput.value, 'YYYY-MM-DD').toDate() : null;
    let deadline = deadlineDatepickerInput?.value ? moment(deadlineDatepickerInput.value, 'YYYY-MM-DD').toDate() : null;
    let recurrence = recurrenceSelectInput?.value ? recurrenceSelectInput.value : null;

    return { start_date, deadline, recurrence };
  }

  function getRecurrenceData() {
    const { recurrence } = getDateInputsValues();

    const days = RECURRENCES_DURATION_DATA[recurrence]?.days || 0;
    const warnDays = RECURRENCES_DURATION_DATA[recurrence]?.warnDays || 0;
    const thresholdDays = RECURRENCES_DURATION_DATA[recurrence]?.days - warnDays;
    return { days, warnDays, thresholdDays };
  }

  function buildTasks() {
    const { start_date, deadline, recurrence } = getDateInputsValues();

    const tasks = [];

    const today = new Date();
    const todayFull = new Date(today.getFullYear(), today.getMonth(), today.getDate());

    if (start_date && deadline) {
      // se suma 1 dia para el cuadro rojo quede al dia siguiente del deadline
      const endIncluded = addRecurrence(addRecurrence(deadline, 'daily'), 'daily')

      tasks.push({
        id: 'current_activity',
        name: nameInput?.value || 'Actividad',
        start: moment(todayFull).format('YYYY-MM-DD'),
        end: moment(endIncluded).format('YYYY-MM-DD'),
        progress: 100,
        custom_class: 'current-activity'
      });

      if (recurrence && recurrence !== 'spot') {
        const { thresholdDays } = getRecurrenceData();

        const nextCreationDate = new Date(start_date.getTime());
        const nextDeadline = addRecurrence(deadline, recurrence);
        nextCreationDate.setDate(nextCreationDate.getDate() + thresholdDays);

        // se suma 1 dia para el cuadro rojo quede al dia siguiente del deadline
        const nextEndIncluded = addRecurrence(addRecurrence(nextDeadline, 'daily'), 'daily');;

        tasks.push({
          id: 'next_activity',
          name: 'Sig. Actividad',
          start: moment(nextCreationDate).format('YYYY-MM-DD'),
          end: moment(nextEndIncluded).format('YYYY-MM-DD'),
          progress: 100,
          dependencies: 'current_activity',
          custom_class: 'next-activity'
        });
      }
    }

    return tasks;
  }

  function explainGantt() {
    const { start_date, deadline, recurrence } = getDateInputsValues();
    const { days, warnDays, thresholdDays } = getRecurrenceData();

    const explainContainer = document.getElementById('gantt-explain');
    if (!explainContainer) return;

    explainContainer.innerHTML = '';

    const detailsCurrentActivityBlock = document.createElement('div');
    const detailsNextActivityBlock = document.createElement('div');
    detailsCurrentActivityBlock.className = 'card';
    detailsNextActivityBlock.className = 'card';

    const activityRecurrenceTranslated = I18n.t(`activerecord.attributes.compliance/activity.recurrence.${recurrence}`);

    if (start_date && deadline && recurrence && recurrence !== 'spot') {
      const nextCreationDate = new Date(start_date.getTime());
      const nextStartDate = addRecurrence(start_date, recurrence);
      const nextDeadline = addRecurrence(deadline, recurrence);

      const overdueStart = new Date(nextDeadline.getFullYear(), nextDeadline.getMonth(), nextDeadline.getDate());
      overdueStart.setDate(overdueStart.getDate() + 1);

      nextCreationDate.setDate(nextCreationDate.getDate() + thresholdDays);

      detailsNextActivityBlock.innerHTML = `
        <div class="card-body">
          <h5 class="text-info mb-0">
            La Siguiente se iniciará a partir del
            <strong>${moment(nextStartDate).format('DD/MM/YYYY')}</strong> con una recurrencia
            <strong>${activityRecurrenceTranslated}</strong>.
          </h5>
          <div class="small text-muted mt-2">
            <ul class="mb-0 pl-3">
              <li>Ciclo: <strong>${days}</strong> días (${activityRecurrenceTranslated})</li>
              <li>Fecha de inicio: <strong>${moment(nextStartDate).format('DD/MM/YYYY')}</li>
              <li>Dias previos de planificación: <strong>${warnDays}</strong> días <strong>(planificación de la actividad)</strong></li>
              <li>Fecha de creación: <strong>${moment(nextCreationDate).format('DD/MM/YYYY')}</strong> (Se toma la fecha de inicio - los dias previos de planificación <strong>(${warnDays})</strong>)</li>
              <li>Fecha de cumplimiento: <strong>${moment(nextDeadline).format('DD/MM/YYYY')}</strong></li>
              <li>Si a la fecha <strong>${moment(overdueStart).format('DD/MM/YYYY')}</strong> no se ha completado, se considera atrasada</li>
            </ul>
          </div>
        </div>
      `;
    }

    detailsCurrentActivityBlock.innerHTML = `
      <div class="card-body">
        <h5 class="text-info mb-0">
          Esta actividad se iniciará a partir del
          <strong>${moment(start_date).format('DD/MM/YYYY')}</strong> con una recurrencia
          <strong>${activityRecurrenceTranslated}</strong>.
        </h5>
        <div class="small text-muted mt-2">
          <ul class="mb-0 pl-3">
            <li>Ciclo: <strong>${days}</strong> días (${activityRecurrenceTranslated})</li>
            <li>Fecha de creación: <strong>${moment(new Date()).format('DD/MM/YYYY')}</strong> </li>
            <li>Fecha de inicio: <strong>${moment(start_date).format('DD/MM/YYYY')}</li>
            <li>Dias previos de planificación: <strong>${start_date.getDate() - new Date(Date.now()).getDate() || 0}</strong> días <strong>(planificación de la actividad)</strong></li>
            <li>Fecha de cumplimiento: <strong>${moment(deadline).format('DD/MM/YYYY')}</strong></li>
            <li>Si a la fecha <strong>${moment(addRecurrence(deadline, 'daily')).format('DD/MM/YYYY')}</strong> no se ha completado, se considera atrasada</li>
          </ul>
        </div>
      </div>
    `;

    explainContainer.appendChild(detailsCurrentActivityBlock);
    explainContainer.appendChild(detailsNextActivityBlock);
  }

  function legendActivityState() {
    const legendActivityStateContainer = document.getElementById('gantt-legend-activity-state');
    if (!legendActivityStateContainer) return;

    legendActivityStateContainer.innerHTML = '';

    const card = document.createElement('div');
    card.className = 'card';
    card.innerHTML = `
      <div class="card-body">
        <div class="d-flex align-items-center mb-1">
          <span class="badge badge-soft-warning mr-2" style="color: #fe7e13; border: 1px solid #fe7e13; background: rgb(255, 243, 234);">Planificada</span>
          <small>La actividad estara en estado planificada hasta un dia antes de la fecha de inicio <strong>(No estará disponible para ser completada)</strong></small>
        </div>
        <div class="d-flex align-items-center mb-1">
          <span class="badge badge-soft-warning mr-2">Pendiente</span>
          <small>La actividad estara en estado pendiente desde la fecha de inicio <strong>(Estará disponible para ser completada)</strong></small>
        </div>
        <div class="d-flex align-items-center mb-1">
          <span class="badge badge-soft-danger mr-2">Atrasada</span>
          <small>La actividad estara en estado atrasada si no se ha completado <strong>(Después de la fecha de cumplimiento)</strong></small>
        </div>
      </div>
    `;
    legendActivityStateContainer.appendChild(card);
  }

  function applySegmentedProgress(activity){
    const { start_date, deadline, recurrence } = getDateInputsValues();
    if (!start_date || !deadline) return;

    const startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());

    let barStart, p1Date, p2Date, endDate;

    if (activity === 'current-activity') {
      if (!start_date) return;

      // base = hoy (inicio visible de la barra actual)
      barStart = startOfDay(new Date());

      // corte 1: al inicio (naranja hasta el día previo al inicio)
      p1Date  = startOfDay(start_date);

      // corte 2: desde el día posterior al deadline
      p2Date  = startOfDay(addRecurrence(deadline, 'daily'));

      // fin: hasta el siguiente día completo
      endDate = startOfDay(addRecurrence(addRecurrence(deadline, 'daily'), 'daily'));
    }

    if (activity === 'next-activity') {
      if (!recurrence || recurrence === 'spot') return;

      const { thresholdDays } = getRecurrenceData();

      // fechas del siguiente ciclo
      const nextCreationDate = startOfDay(start_date);
      nextCreationDate.setDate(nextCreationDate.getDate() + thresholdDays);
      const nextStartDate    = startOfDay(addRecurrence(start_date, recurrence));
      const nextDeadline     = startOfDay(addRecurrence(deadline, recurrence));

      // base = fecha de creación de la siguiente actividad
      barStart = nextCreationDate;

      // corte 1: al inicio (naranja hasta el día previo al inicio)
      p1Date = nextStartDate;

      // corte 2: desde el día posterior al próximo deadline
      p2Date  = startOfDay(addRecurrence(nextDeadline, 'daily'));
      // fin: hasta el siguiente día completo
      endDate = startOfDay(addRecurrence(addRecurrence(nextDeadline, 'daily'), 'daily'));
    }

    const total = endDate - barStart;
    if (total <= 0) return;

    const clamp = (v) => Math.max(0, Math.min(100, v));
    const p1 = clamp(((p1Date - barStart) / total) * 100);
    const p2 = clamp(((p2Date - barStart) / total) * 100);

    const svg = document.querySelector('#gantt-embed svg');
    if (!svg) return;

    const svgns = 'http://www.w3.org/2000/svg';
    let defs = svg.querySelector('defs');
    if (!defs) {
      defs = document.createElementNS(svgns, 'defs');
      svg.insertBefore(defs, svg.firstChild);
    }

    const gradId = `grad-${activity}`;
    const prev = svg.querySelector(`#${gradId}`);
    if (prev) prev.remove();

    const grad = document.createElementNS(svgns, 'linearGradient');
    grad.setAttribute('id', gradId);
    grad.setAttribute('x1', '0%'); grad.setAttribute('y1', '0%');
    grad.setAttribute('x2', '100%'); grad.setAttribute('y2', '0%');

    const stops = [
      { offset: 0, color: '#fe7e13' },
      { offset: p1, color: '#fe7e13' },
      { offset: p1, color: '#FFC107' },
      { offset: p2, color: '#FFC107' },
      { offset: p2, color: '#dd3a4a' },
      { offset: 100, color: '#dd3a4a' }
    ];

    stops.forEach(({offset, color}) => {
      const s = document.createElementNS(svgns, 'stop');
      s.setAttribute('offset', `${offset}%`);
      s.setAttribute('stop-color', color);
      grad.appendChild(s);
    });
    defs.appendChild(grad);

    const progress = document.querySelector(`.bar-wrapper.${activity} .bar-progress`) || document.querySelector(`.bar-progress.${activity}`);

    if (progress) {
      progress.style.fill = `url(#${gradId})`;
      progress.style.stroke = 'none';
      progress.style.shapeRendering = 'crispEdges';
    }
  }

  function renderGantt() {
    const ganttEmbedContainer = document.getElementById('gantt-embed');
    if (!ganttEmbedContainer) return;

    ganttEmbedContainer.innerHTML = '';

    const tasks = buildTasks();

    if (tasks.length === 0) {
      const alert = document.createElement('div');
      alert.className = 'alert alert-warning alert-dismissible fade show mb-0';
      alert.setAttribute('role', 'alert');
      alert.innerHTML = `
        Seleccione una fecha de inicio, una fecha de cumplimiento y una recurrencia para obtener la previsualización
      `;
      ganttEmbedContainer.appendChild(alert);
      return;
    }else{
      explainGantt();
      legendActivityState();
    }

    ganttInstance = new Gantt(ganttEmbedContainer, tasks, {
      view_mode: 'Day',
      language: 'es',
      custom_popup_html: null,
      container_height: '350'
    });

    setTimeout(() => applySegmentedProgress('current-activity'), 0);
    setTimeout(() => applySegmentedProgress('next-activity'), 0);
  }

  function addFieldListeners() {
    COMPLIANCE_ACTIVITY_FIELDS_LIST.forEach(
      function(field_name) {
        const field = document.getElementById(field_name);
        if (!field) return;

        field.addEventListener('change', renderGantt);
        field.addEventListener('input', renderGantt);
      }
    );
  }

  activityGanttModal.addEventListener('shown.bs.modal', function() {
    renderGantt();
    addFieldListeners();

    const ganttEmbedContainer = document.getElementById('gantt-embed');
    if (ganttEmbedContainer && !ganttEmbedContainer.dataset.wheelBound) {
      ganttEmbedContainer.addEventListener('wheel', (e) => {
        if (e.deltaY !== 0 && !e.shiftKey) {
          e.preventDefault();
          ganttEmbedContainer.scrollLeft += e.deltaY;
        }
        applySegmentedProgress('current-activity');
        applySegmentedProgress('next-activity');
      }, { passive: false });
      ganttEmbedContainer.dataset.wheelBound = '1';
    }
  });
}